import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';
import { ChangeRequestModel, ValidationUpdateModel } from '../model/types';

export type ValidationUpdateArgs = {
    appHash?: string;
    validationUpdateModel: ValidationUpdateModel;
};

export type ValidationConfirmArg = {
    id: number | string;
    smsCode?: string;
    twoFactorCode?: string;
    headers?: Record<string, string>;
};

export type ValidationResendArg = {
    id: number | string;
    appHash?: string;
};

const validateApi = api.injectEndpoints({
    endpoints: (build) => ({
        validationUpdate: build.mutation<
            ApiResponse<ChangeRequestModel>,
            ValidationUpdateArgs
        >({
            query: (queryArg) => ({
                url: `/user/validation/update`,
                method: 'POST',
                body: queryArg.validationUpdateModel,
                params: { appHash: queryArg.appHash },
            }),
        }),
        validationConfirm: build.mutation<
            ApiResponse<ChangeRequestModel>,
            ValidationConfirmArg
        >({
            query: (queryArg) => ({
                url: `/user/validation/${queryArg.id}/confirm`,
                method: 'POST',
                headers: queryArg.headers,
                params: {
                    smsCode: queryArg.smsCode,
                    twoFactorCode: queryArg.twoFactorCode,
                },

            }),
        }),
        validationResend: build.query<
            ApiResponse<ChangeRequestModel>,
            ValidationResendArg
        >({
            query: (queryArg) => ({
                url: `/user/validation/${queryArg.id}/resend`,
                params: { appHash: queryArg.appHash },
            }),
        }),
    }),
});

export const {
    useValidationConfirmMutation,
    useLazyValidationResendQuery,
    useValidationUpdateMutation,
} = validateApi;

export default validateApi;
